import _ from 'lodash'

import { eventEmitter } from '@/event-bus'
import i18n from '@/i18n/i18n'
import { DocumentProcessService } from '@/services/admin/DocumentProcessService'
import FarmerService from '@/services/admin/FarmerService'
import { errorMessage } from '@/utilities/helpers'

import { DOCUMENT_PROCESS_TYPE_MAP } from '@/constants/documentProcessType'

const { t } = i18n.global

export const namespaced = true

export const state = {
  processes: null,
  controlProcesses: null,
  process: {},
  farmer: null
}

export const mutations = {
  SET_PROCESSES(state, processes) {
    state.processes = processes.data
  },
  SET_CONTROL_PROCESSES(state, processes) {
    state.controlProcesses = processes.data
  },
  ADD_CONTROL_PROCESS(state, process) {
    state.controlProcesses.push(process)
  },
  ADD_PROCESS(state, process) {
    state.processes.push(process)
  },
  SET_PROCESS(state, process) {
    state.process = process
  },
  UPDATE_PROCESS(state, process) {
    state.process = process
  },
  UPDATE_CONTROL_PROCESS(state, process) {
    state.controlProcesses = process
  },
  DELETE_PROCESS(state, process) {
    let index = _.findIndex(state.processes, p => {
      return p.id === process.id
    })

    state.processes[index] = process
  },
  SET_FARMER(state, farmer) {
    state.farmer = farmer
  }
}

export const actions = {
  getProcesses({ commit }, document) {
    return new Promise(resolve => {
      let documentProcessService = new DocumentProcessService()

      documentProcessService.getProcesses(document).then(response => {
        commit('SET_PROCESSES', response)
        resolve(response.data)
      })
    })
  },
  exportControlProcess({ commit, dispatch }, document) {
    return new Promise((resolve, reject) => {
      let documentProcessService = new DocumentProcessService()

      documentProcessService
        .exportControlProcess(document)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.export_started')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getProcess({ commit }, params) {
    return new Promise(resolve => {
      let documentProcessService = new DocumentProcessService()

      documentProcessService.getProcess(params.document, params.process).then(response => {
        commit('SET_PROCESS', response.data)
        resolve(response.data)
      })
    })
  },
  updateProcess({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let documentProcessService = new DocumentProcessService()
      documentProcessService
        .updateProcess(params.document, params.process, params.form)
        .then(response => {
          const notification = {
            type: 'success',
            message:
              response.data.type === DOCUMENT_PROCESS_TYPE_MAP.FARMER_IDENTITY_CARD
                ? t('store.shared.assigned_to_farmer', {
                    element: t('store.admin.document.farmer_identity_card')
                  })
                : t('store.shared.assigned_to_relevant_sale', {
                    element: t('store.admin.document.document')
                  })
          }
          dispatch('notification/add', notification, {
            root: true
          })

          if (response.data.type !== DOCUMENT_PROCESS_TYPE_MAP.FARMER_IDENTITY_CARD) {
            commit('UPDATE_PROCESS', response.data)
          }

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'warning',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteProcess({ commit, dispatch }, param) {
    return new Promise((resolve, reject) => {
      let documentProcessService = new DocumentProcessService()

      documentProcessService
        .deleteProcess(param.document, param.id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.removed', { element: t('store.admin.document.document') })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('DELETE_PROCESS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  getFarmerByTckn({ commit }, tckn) {
    return new Promise((resolve, reject) => {
      FarmerService.getInfo(tckn)
        .then(response => {
          commit('SET_FARMER', response.data)
          resolve(response.data)
        })
        .catch(err => {
          eventEmitter.emit('addError', {
            type: 'farmerByTckn',
            message: errorMessage(err)
          })
          commit('SET_FARMER', null)
          reject(err)
        })
    })
  }
}
